// extracted by mini-css-extract-plugin
module.exports = {"reviewsDate":"review-time-ago_reviewsDate__2eFnw","absolute":"review-time-ago_absolute__SMCB3","none":"review-time-ago_none__K_97w"};